var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "main",
    [
      _c("a", { ref: "topAnchor", attrs: { name: _vm.topAnchorName } }),
      _vm._v(" "),
      _c("table-non-field-filters", {
        attrs: {
          fields: _vm.fields,
          prefix: _vm.prefix,
          filters: _vm.nonFieldFilters,
          isTableLoading: _vm.isLoading,
        },
        on: { search: _vm.onSearch, filter: _vm.onFilter },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "tc-table-2-scroll-wrapper" }, [
        _c(
          "div",
          { staticClass: "tc-table-2", class: [`has-layout-${_vm.layout}`] },
          [
            _c("div", { staticClass: "table-header" }, [
              _c(
                "div",
                { staticClass: "table-row header-row" },
                [
                  _vm.settings.selection_enabled
                    ? _c(
                        "div",
                        {
                          staticClass: "select-all-cell header-cell table-cell",
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.allSelected,
                                expression: "allSelected",
                              },
                            ],
                            attrs: { type: "checkbox" },
                            domProps: {
                              checked: Array.isArray(_vm.allSelected)
                                ? _vm._i(_vm.allSelected, null) > -1
                                : _vm.allSelected,
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.allSelected,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.allSelected = $$a.concat([$$v]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.allSelected = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.allSelected = $$c
                                }
                              },
                            },
                          }),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.fields, function (field, index) {
                    return _c("header-cell", {
                      key: field.name,
                      attrs: {
                        prefix: _vm.prefix,
                        filters: _vm.filters.filter(
                          (o) => o.field_name == field.name
                        ),
                        field: field,
                        index: index,
                        isTableLoading: _vm.isLoading,
                      },
                      on: { sort: _vm.onSort, filter: _vm.onFilter },
                    })
                  }),
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "table-body" },
              _vm._l(_vm.objects, function (object, index) {
                return _c("table-row", {
                  key: index,
                  attrs: {
                    fields: _vm.fields,
                    object: object,
                    "selection-enabled": _vm.settings.selection_enabled,
                    "is-selected": _vm.selected.indexOf(object._pk_) > -1,
                  },
                  on: { onRowSelected: _vm.onRowSelected },
                })
              }),
              1
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("table-status", { attrs: { pagination: _vm.pagination } }),
      _vm._v(" "),
      _c("table-pagination", {
        attrs: { pagination: _vm.pagination },
        on: { jump: _vm.onJumpPage },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-footer" },
        [
          _vm.settings.is_excel_export_enabled
            ? [
                _c("div", { staticClass: "field has-addons" }, [
                  _c("div", { staticClass: "control" }, [
                    _c(
                      "button",
                      {
                        staticClass: "button",
                        class: { "is-loading": _vm.isDownloadingExcel },
                        attrs: {
                          type: "button",
                          disabled:
                            _vm.isLoading ||
                            _vm.isDownloadingExcel ||
                            _vm.isDownloadingExcelAllObjects,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.downloadExcel(false)
                          },
                        },
                      },
                      [
                        _c("bulma-icon", {
                          attrs: { name: "fas fa-download" },
                        }),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.$pgettext("core.table", "Download excel")
                            )
                          ),
                        ]),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "control" },
                    [
                      _c(
                        "bulma-dropdown",
                        {
                          ref: "excelExportDropdown",
                          staticClass: "is-right is-up",
                          attrs: {
                            disabled:
                              _vm.isLoading ||
                              _vm.isDownloadingExcel ||
                              _vm.pagination.total_object_count <=
                                _vm.pagination.per_page,
                          },
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "control dropdown-item",
                              class: {
                                "is-loading": _vm.isDownloadingExcelAllObjects,
                              },
                              attrs: {
                                disabled:
                                  _vm.isLoading ||
                                  _vm.isDownloadingExcel ||
                                  _vm.isDownloadingExcelAllObjects ||
                                  _vm.isTooManyRows,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.downloadExcel(true)
                                },
                              },
                            },
                            [
                              _c("bulma-icon", {
                                attrs: { name: "fas fa-download" },
                              }),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$pgettext(
                                      "core.table",
                                      `All ${_vm.pagination.total_object_count} rows`
                                    )
                                  ) + " "
                                ),
                              ]),
                              _vm._v(" "),
                              _vm.isTooManyRows
                                ? [
                                    _c("bulma-icon", {
                                      staticClass: "has-text-danger",
                                      staticStyle: {
                                        position: "absolute",
                                        right: "4px",
                                      },
                                      attrs: {
                                        name: "fas fa-exclamation-triangle",
                                        title: _vm.$pgettext(
                                          "core.table",
                                          "Too many rows - please filter results to get smaller amount of rows before exporting!"
                                        ),
                                      },
                                    }),
                                  ]
                                : _vm.pagination.total_object_count > 10000
                                ? [
                                    _c("bulma-icon", {
                                      staticClass: "has-text-danger",
                                      staticStyle: {
                                        position: "absolute",
                                        right: "4px",
                                      },
                                      attrs: {
                                        name: "fas fa-exclamation-triangle",
                                        title: _vm.$pgettext(
                                          "core.table",
                                          "Large number of rows - this might take a while!"
                                        ),
                                      },
                                    }),
                                  ]
                                : _vm._e(),
                            ],
                            2
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.settings.selection_enabled &&
          _vm.settings.selection_action == _vm.TableSelectionAction.POST_SUBMIT
            ? [
                _c(
                  "form",
                  {
                    attrs: {
                      method: "post",
                      action: _vm.settings.selection_action_url,
                    },
                  },
                  [
                    _c("input", {
                      attrs: { type: "hidden", name: `${_vm.prefix}selected` },
                      domProps: { value: _vm.selected.join(",") },
                    }),
                    _vm._v(" "),
                    _c("csrf-hidden-input-field"),
                    _vm._v(" "),
                    _c("input", {
                      attrs: { type: "hidden", name: "app_label" },
                      domProps: { value: _vm.meta.app_label },
                    }),
                    _vm._v(" "),
                    _c("input", {
                      attrs: { type: "hidden", name: "model_name" },
                      domProps: { value: _vm.meta.model_name },
                    }),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "button is-primary",
                        attrs: { type: "submit" },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.settings.selection_action_label) +
                            "\n                "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }